module.exports = __webpack_public_path__ + "img/na.3143eefa.svg";